{
    let tabs = document.querySelectorAll('[data-tabs]');

    if (tabs !== null) {
        document.addEventListener('click', e => {
            if (!e.target.matches('[data-tabs] a')) {
                return;
            }

            e.preventDefault();

            let parent = e.target.closest('[data-tabs]');
            let content_slug = parent.getAttribute('id');
            let target_slug = e.target.getAttribute('href').substr(1);

            parent.querySelectorAll('a').forEach((link) => {
                link.classList.remove('is-active');
            });

            e.target.classList.add('is-active');

            let content = document.querySelector(`[data-tabs-content="${content_slug}"]`);

            content.querySelectorAll('.tabs-panel').forEach((el) => {
                el.classList.remove('is-active');
            });

            let tab = document.querySelector(`[data-tabs-content="${content_slug}"] .tabs-panel#${target_slug}`);
            tab.classList.add('is-active')
        });
    }

    let slider = document.querySelector('.tabs');

    if (slider !== null) {
        let isDown = false;
        let startX;
        let scrollLeft;
        let hasMoved = false;

        slider.addEventListener('mousedown', (e) => {
            isDown = true;
            hasMoved = false;

            slider.classList.add('active-drag');

            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });

        window.addEventListener('mousemove', (e) => {
            if (!isDown) return;

            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 1.5;

            if (Math.abs(walk) > 5) {
                hasMoved = true;
            }

            slider.scrollLeft = scrollLeft - walk;
        });

        window.addEventListener('mouseup', () => {
            isDown = false;
            if (slider) slider.classList.remove('active-drag');
        });

        slider.addEventListener('click', (e) => {
            if (hasMoved) {
                e.preventDefault();
                e.stopPropagation();
            }
        }, { capture: true });
    }
}
